'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { logger, reloadOnChunkError } from '@/shared/logger';
import { ErrorPage } from '@/shared/ui';
import { useTranslations } from 'next-intl';
import { ErrorInfo, getErrorInfo } from '../model/lib';
interface ErrorFallbackProps {
  // app-router error.tsx 가 넘겨주는 error 는 digest(서버 에러 상관 ID)를 가질 수 있음
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function ErrorFallback(t0) {
  const $ = _c(24);
  const {
    error,
    reset
  } = t0;
  const t = useTranslations("error");
  const [errorInfo, setErrorInfo] = useState();
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      reloadOnChunkError(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== error || $[4] !== t) {
    t3 = () => {
      setErrorInfo(getErrorInfo(error, t));
    };
    t4 = [error, t];
    $[3] = error;
    $[4] = t;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] !== error || $[8] !== errorInfo) {
    t5 = () => {
      if (!error || !errorInfo) {
        return;
      }
      logger.error({
        err: error,
        digest: error.digest,
        status: errorInfo.status,
        displayMessage: errorInfo.message
      }, "error boundary caught");
    };
    t6 = [error, errorInfo];
    $[7] = error;
    $[8] = errorInfo;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== reset) {
    t7 = () => {
      reset();
      window.location.href = "/";
    };
    $[11] = reset;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleClickHome = t7;
  let t8;
  if ($[13] !== t) {
    t8 = t("errorPage.title");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== errorInfo?.message || $[16] !== t) {
    t9 = errorInfo?.message ?? t("errorPage.unexpected");
    $[15] = errorInfo?.message;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = [t9];
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== handleClickHome || $[21] !== t10 || $[22] !== t8) {
    t11 = <ErrorPage title={t8} description={t10} onClickHome={handleClickHome} />;
    $[20] = handleClickHome;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}